import {
  Box,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import React, { FC } from "react";

import { SortOption } from "../../../../types/table";

interface SortContentButtonsProps {
  localSort: SortOption;
  handleSortToggle: (
    _: React.MouseEvent<HTMLElement, MouseEvent>,
    value: SortOption | null,
  ) => void;
}

export const SortContentButtons: FC<SortContentButtonsProps> = ({
  localSort,
  handleSortToggle,
}) => {
  return (
    <Box
      sx={{
        px: 2,
        pt: 1.5,
        display: "flex",
        flexDirection: "row",
        gap: 1,
        alignItems: "center",
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <Typography
        variant="body2"
        color="text.secondary"
        fontWeight={500}
        sx={{ width: "45px" }}
      >
        Sort
      </Typography>

      <ToggleButtonGroup
        value={localSort}
        exclusive
        onChange={handleSortToggle}
        size="small"
        fullWidth
        variant="segmented"
      >
        <ToggleButton value="default">Default</ToggleButton>
        <ToggleButton value="asc">Asc.</ToggleButton>
        <ToggleButton value="desc">Desc.</ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};
